import { gql } from '@apollo/client';

const MOVIE_FIELDS = `
  id
  title
  releaseYear
  posterUrl
  director
  cast
  genres
  runtime
  status
  rating
  favorite
  watchedDate
  rewatch
  review
  notes
  spoiler
  collection
  whereWatched
  updatedAt
`;

const MOVIE_IMPORT_FIELDS = `
  title
  releaseYear
  posterUrl
  director
  cast
  genres
  runtime
  status
  rating
  favorite
  watchedDate
  rewatch
  review
  notes
  spoiler
  collection
  whereWatched
`;

export const GET_MOVIES = gql`
  query GetMovies($first: Int, $after: String) {
    getMoviesPage(first: $first, after: $after) {
      nodes {
        ${MOVIE_FIELDS}
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_MOVIE = gql`
  query GetMovie($id: ID!) {
    getMovie(id: $id) {
      ${MOVIE_FIELDS}
    }
  }
`;

export const ADD_MOVIE = gql`
  mutation AddMovie($input: MovieInput!) {
    addMovie(input: $input) {
      ${MOVIE_FIELDS}
    }
  }
`;

export const UPDATE_MOVIE = gql`
  mutation UpdateMovie($id: ID!, $input: MovieInput!) {
    updateMovie(id: $id, input: $input) {
      ${MOVIE_FIELDS}
    }
  }
`;

export const DELETE_MOVIE = gql`
  mutation DeleteMovie($id: ID!) {
    deleteMovie(id: $id)
  }
`;

export const SEARCH_MOVIES = gql`
  query SearchMovies($query: String!) {
    searchMovies(query: $query) {
      tmdbId
      title
      releaseYear
      posterUrl
      director
      cast
      genres
      runtime
      overview
    }
  }
`;

export const PREVIEW_LETTERBOXD_IMPORT = gql`
  mutation PreviewLetterboxdImport($input: LetterboxdImportPreviewInput!) {
    previewLetterboxdImport(input: $input) {
      totalRows
      importableCount
      duplicateCount
      maxBatchSize
      items {
        rowId
        duplicate
        duplicateReason
        movie {
          ${MOVIE_IMPORT_FIELDS}
        }
      }
    }
  }
`;

export const IMPORT_LETTERBOXD_MOVIES = gql`
  mutation ImportLetterboxdMovies($input: LetterboxdImportInput!) {
    importLetterboxdMovies(input: $input) {
      importedCount
      skippedCount
      failedCount
      movies {
        ${MOVIE_FIELDS}
      }
      failures {
        rowId
        title
        message
      }
    }
  }
`;
